module.exports = __webpack_public_path__ + "static/media/home-graphic-6.de59faf2.png";